import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFailureGraphic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 514,
	height: 514,
	viewBox: "0 0 514 514",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M257 503.8C393.304 503.8 503.8 393.304 503.8 257C503.8 120.696 393.304 10.2002 257 10.2002C120.696 10.2002 10.2002 120.696 10.2002 257C10.2002 393.304 120.696 503.8 257 503.8Z",
			fill: "#FFF1F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 101,
			y: 101,
			width: 312,
			height: 312,
			rx: 156,
			fill: "#940A0A"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M257 413C343.157 413 413 343.156 413 257C413 170.844 343.157 101 257 101C170.844 101 101 170.844 101 257C101 343.156 170.844 413 257 413ZM339.474 316.489C345.82 322.835 345.82 333.124 339.474 339.47C333.128 345.816 322.839 345.816 316.493 339.47L256.745 279.722L196.992 339.475C190.646 345.821 180.357 345.821 174.011 339.475C167.665 333.129 167.665 322.84 174.011 316.494L233.764 256.741L174.011 196.988C167.665 190.642 167.665 180.353 174.011 174.007C180.357 167.661 190.646 167.661 196.992 174.007L256.745 233.76L316.493 174.012C322.839 167.666 333.128 167.666 339.474 174.012C345.82 180.358 345.82 190.647 339.474 196.993L279.726 256.741L339.474 316.489Z",
			fill: "#FFB8B3"
		})
	]
});
export default SvgFailureGraphic;
